import { createFileRoute } from '@tanstack/react-router'
import { AccountSettingsPage } from '@/features/account-settings'
import { requireAccess } from '@/app/router/route-guards'
import { Permission } from '@/lib/rbac'

export const Route = createFileRoute('/_auth/account-settings')({
  beforeLoad: () => requireAccess({ permission: Permission.AccountSettingsManage }),
  component: AccountSettingsPage,
})
